export default __webpack_public_path__ + "static/media/Heebo-Thin.2ee1fe16.ttf";